/*******************************************************************************
* @license
* Copyright (c) 2016 - present Accedo. All Rights Reserved.
* 
* This source code, its use, and distribution, is subject to the terms
* and conditions of the applicable license agreement.
* 
* Accedo Build XDK Core (@accedo/xdk-core) 4.2.6
* 
*******************************************************************************/
let CONSTANT_DESCRIPTOR={configurable:!1,enumerable:!0,writable:!1};function withValue(e){let a=CONSTANT_DESCRIPTOR;return a.value=e,a}function toUpperSnakeCase(e){return`${e}`.toUpperCase().replace("-","_")}export default{toUpperSnakeCase:toUpperSnakeCase,withValue:withValue};